import wx from 'weixin-js-sdk'
import publicObj from './public'
import store from '@store'
import router from '@router'


export default {
  // 1=微信, 2=支付宝
  payTypeObj:{
    weiXin:1,
    aliPay: 2
  },
  // 发起支付的应用类型,11=微信MWEB,12=微信JSAPI,13=微信APP,14=微信NATIVE扫码支付;21=支付宝h5,22=支付宝app
  clientType: {
    mWeb: 11,
    JSApi: 12,
    JSApiMini: 13,
    aliPay: 21,
    PC:0
  },
  //支付成功后跳转页面
  // 买家订单列表
  purchaseOrder: location.origin + '/order/purchaseOrder',
  myIndex:location.origin + '/my',
  //支付成功
  paySuccessUrl: location.origin + '/paySuccess',
  backUrl:'',
  backType:'',
  backTypeObj:{
    product:1,
    order:2,
    service:3,
    direct:4
  },
  // 获取支付参数
  getPayParams(params) {
    // 默认跳转支付成功页面
    const payType = params.payType || this.payTypeObj.weiXin;
    this.backType = params.backType;
    if(params.backType === this.backTypeObj.service){
      // 续费支付
      this.backUrl = this.myIndex;
    }else if(params.backType === this.backTypeObj.direct){
      //直接支付
      this.backUrl = location.origin+'/payCompleted';
    } else {
      // 订单支付和商品支付
      if(params.orderType){
        this.backUrl = this.paySuccessUrl+'?orderCode='+params.orderCode+'&payType='+payType+"&orderType="+params.orderType;
      }else{
        this.backUrl = this.paySuccessUrl+'?orderCode='+params.orderCode+'&payType='+payType
      }
    }

    let obj = {
      clientType: '',
      payType:payType, // 默认微信支付
      backUrl: this.backUrl,

    };
    if(!publicObj.isWeiXin() && obj.payType === this.payTypeObj.aliPay){
      // 微信外 且用户选择支付宝支付
      obj.clientType = this.clientType.aliPay;
      obj.payType = this.payTypeObj.aliPay
    }else {
      if(publicObj.isWeiXinMiNi()){
        //微信小程序内支付
        obj.clientType = this.clientType.JSApiMini;
        if(store.state.user.userInfo.weChatMAOpenId){
          obj.wxOpenId = store.state.user.userInfo.weChatMAOpenId
        }else{
          publicObj.clearThenToLogin()
        }
        
      }else if(publicObj.isWeiXin()){
        //服务号支付
        obj.clientType = this.clientType.JSApi;

        if(store.state.user.userInfo.weChatMPOpenId){
          obj.wxOpenId = store.state.user.userInfo.weChatMPOpenId
        }else{
          publicObj.clearThenToLogin()
        }

      }else {
      //  微信外 微信支付
        obj.clientType = this.clientType.mWeb
      }
    }
    // alert(JSON.stringify(obj))
    return obj
  },
  isWeiXinApp(clientType,data){
    return new Promise(resolve => {
      if(clientType ===  this.clientType.JSApiMini){
        let params = '';
        if(data.orderCode){
          //商品支付
          params = '?orderCode='+data.orderCode
        }else if( data.id){
          //续费
          params = '?id='+data.id
        }
        if(data.remainTime){
          params+='&remainTime='+data.remainTime
        }
        wx.miniProgram.navigateTo({url: '/pages/pay/index'+params});
      }else {
        resolve('非微信小程序内')
      }
    })


  },
  //确认支付
  confirmPay(clientType, data,orderType) {
    const _this = this;
    // alert(JSON.stringify(data))
    switch (clientType) {
      case this.clientType.mWeb:
        //微信外 微信支付
        location.href = data.h5PayUrl;
        break;
      case this.clientType.aliPay:
        // 微信外 支付宝支付
        location.href = data.h5PayUrl;
        break;
      case this.clientType.JSApi:
        // 微信内 微信支付
        wx.ready(function () {
          const {timestamp, nonceStr, packageStr, signType, paySign} = data.chooseWXPayParam;
          let config = {
            timestamp,
            nonceStr,
            package: packageStr,
            signType,
            paySign,
          };
          wx.chooseWXPay({
            ...config,
            success: function (res) {
              location.replace(_this.backUrl)
              //诸葛：支付成功
              if (orderType) {
                let zhugeName = orderType !== "3" ? "换背" : "购买"
                zhuge.track(zhugeName + "-支付成功");
              }
            },
            cancel:function(res){
              // alert('支付取消');
              //  跳转订单列表
              switch (_this.backType) {
                case _this.backTypeObj.product:
                  router.replace({name:'purchaseOrder'});
                  break;
                case _this.backTypeObj.order:
                  router.replace({name:'purchaseOrder'});
                  break;
              }
            },
            fail: function (res) {
              // alert(JSON.stringify(res));
              //诸葛：支付失败
              if(orderType){
                let zhugeName=orderType!=="3"?"换背":"购买"
                zhuge.track(zhugeName+"-支付失败", {
                  "失败原因":JSON.stringify(res)
                });
              }
              switch (_this.backType) {
                case _this.backTypeObj.product:
                  router.replace({name:'purchaseOrder'});
                  break;
                case _this.backTypeObj.order:
                  router.replace({name:'purchaseOrder'});
                  break;
              }
            },
            complete: function () {}
          });
        });

        break;

    }

  },

}
